import React from 'react';
import PropTypes from 'prop-types';
import R from 'ramda';
import classNames from 'classnames';
import { connect } from 'react-redux';
import StandardLayout from '../../templates/StandardLayout';
import { ShoppingBagComponent } from '../../molecules/shopping-bag';
import { isSmallBreakpoint } from '../../utils';

const generateContainerClassNames = (isSmall) =>
  classNames('grid-container', {
    full: isSmall,
  });

const Checkout = ({ currentBreakpoint }) => (
  <div className="checkout-page">
    <StandardLayout>
      <div className="checkout-page__main">
        <div
          className={generateContainerClassNames(
            isSmallBreakpoint({ currentBreakpoint })
          )}
        >
          <ShoppingBagComponent />
        </div>
      </div>
    </StandardLayout>
  </div>
);

Checkout.propTypes = {
  currentBreakpoint: PropTypes.string,
};

const mapStateToProps = ({ breakpoints }) => ({
  currentBreakpoint: R.prop('current')(breakpoints),
});

export default connect(mapStateToProps)(Checkout);
